import React, { useState } from 'react';
import { Row, Col, Card } from 'antd';
import CityForm from '../components/city/CityForm';
import CityList from '../components/city/CityList';
import { City } from '../types/city';
import { useTranslation } from 'react-i18next';

const CityPage: React.FC = () => {
    const [selectedCity, setSelectedCity] = useState<City | null>(null);
    const { t } = useTranslation();

    return (
        <Row gutter={[16, 16]}>
            <Col xs={24} md={10} lg={8}>
              <Card title={t('add_edit_city')}>
                  <CityForm selectedCity={selectedCity} setSelectedCity={setSelectedCity} />
              </Card>
          </Col>
            <Col xs={24} md={14} lg={16}>
              <Card title={t('city_list')}>
                  <CityList setSelectedCity={setSelectedCity} />
              </Card>
          </Col>
      </Row>
  );
};

export default CityPage;
